// Sun Valley : onglets du guide des tailles (snippets/sv-guide-tailles.liquid), sur la page du
// guide comme dans le tiroir de la fiche produit. Par délégation : le thème redessine le
// sélecteur de variante, et donc le tiroir, à chaque changement de taille ou de coloris.
// Un lien #femme ou #junior ouvre directement l'onglet sur la page du guide.
(() => {
  const activer = (onglet) => {
    const pile = onglet.closest('[data-sv-tailles]');
    if (!pile) return;
    for (const o of pile.querySelectorAll('[role="tab"]')) {
      const actif = o === onglet;
      o.setAttribute('aria-selected', String(actif));
      if (actif) o.removeAttribute('tabindex'); else o.setAttribute('tabindex', '-1');
      const panneau = document.getElementById(o.getAttribute('aria-controls'));
      if (panneau) panneau.hidden = !actif;
    }
  };

  document.addEventListener('click', (e) => {
    const onglet = e.target.closest('[data-sv-tailles] [role="tab"]');
    if (onglet) activer(onglet);
  });

  const voulu = decodeURIComponent(location.hash.replace('#', '')).toLowerCase();
  if (voulu) {
    const ouvrir = () => {
      for (const o of document.querySelectorAll('[data-sv-tailles] [role="tab"]')) {
        // data-sv-onglet garde le nom français (#femme, #junior) quand l'onglet est traduit
        if (o.dataset.svOnglet === voulu || o.textContent.trim().toLowerCase() === voulu) activer(o);
      }
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ouvrir);
    else ouvrir();
  }
})();
